import PropTypes from "prop-types"

const ItemNameCountShape = {
  count: PropTypes.number.isRequired,
  itemName: PropTypes.string.isRequired,
}
export default ItemNameCountShape



// WEBPACK FOOTER //
// ./src/state/shapes/ItemNameCountShape.js